/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-02 11:31:06
 **/

export default class PreventData {
	constructor(private _init: any = null) {}

	public is_prevent(value: any) {
		if (this._init === value) {
			return true;
		}
		this._init = value;
		return false;
	}
}
